import type { FunctionComponent } from 'react';
import { EmptyEventCard } from '../components/client-package/EmptyEventCard';
import { EventCard } from '../components/client-package/EventCard';
import type { RoadmapEvent } from '../interfaces/event';

interface IProps {
    lifeEvents: RoadmapEvent[];
    images: Record<string, string>;
}

export const TimeLineColumn: FunctionComponent<IProps> = ({ lifeEvents, images }) => {
    const displayedEvents: number = 6;

    const sortedLifeEvents = lifeEvents
        .toSorted((lifeEventA, lifeEventB) => new Date(lifeEventA.dueDate ?? '').getTime() - new Date(lifeEventB.dueDate ?? '').getTime())
        .slice(0, displayedEvents);

    return (
        <>
            <div className="timeline-column">
                <div className={'timeline-column__line timeline-column__line--future'} />
                <div className={'timeline-column__event-container timeline-column__event-container--future'}>
                    <span className="timeline-year">
                        <div className="timeline-item__panel">
                            <div className="timeline-item__content">
                                {sortedLifeEvents.map((lifeEvent) => (
                                    <EventCard key={lifeEvent.name} lifeEvent={lifeEvent} images={images} />
                                ))}
                                {lifeEvents.length > displayedEvents && <EmptyEventCard />}
                            </div>
                        </div>
                    </span>
                </div>
            </div>
        </>
    );
};
